import { i18nConfig } from './app/i18n/settings';

export default i18nConfig;
